import { Button, Card } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setPage, setEbullTab } from "../../../state/slices/generalSlice";
import "../../../styles/pages/homePage/ebulletinQuickLinks.scss";

const EbulletinQuickLinks = () => {
  const { bulletins } = useSelector((state) => state.generalSlice);
  const dispatch = useDispatch();

  console.log(bulletins);

  function handleNavigation(page, eBulletinId) {
    if (!page) return;
    dispatch(setPage(page));
    if (eBulletinId) {
      dispatch(setEbullTab(eBulletinId));
    }
  }

  return (
    <div className="ebul-quicklinks">
      <Card className="ql-card" title="Ebulletin Quicklinks">
        <div className="grid-buttons">
          {bulletins.map((item, index) => (
            <Button
              key={index}
              className="grid-btn"
              style={{
                backgroundImage: `url(${item.cover_image})`,
              }}
              onClick={() => {
                handleNavigation("ebulletin", item.id);
              }}
            >
              <span className="btn-label">{item.title}</span>
            </Button>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default EbulletinQuickLinks;
